import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCbpLocationQuickInfo extends Layout {
    labelAddress1: Label;
    labelAddress2: Label;
    labelId: Label;
    labelLocationName: Label;
    panelCbpLocation: Panel;
    sourceLocation: DataSource;
    textboxPortId: Textbox;
}
